(() => {
  const loadScript = (src, attributes = {}) =>
    new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      Object.assign(script, attributes);
      script.onload = script.onreadystatechange = function handleLoad() {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
          script.onload = script.onreadystatechange = null;
          resolve();
        }
      };
      script.onerror = resolve;
      document.head.appendChild(script);
    });

  const loadAfterIdle = (callback) => {
    const runner = () => {
      if (document.readyState === 'complete') {
        callback();
      } else {
        window.addEventListener('load', callback, { once: true });
      }
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(runner, { timeout: 4000 });
    } else {
      setTimeout(runner, 2000);
    }
  };

  const readJsonConfig = (id) => {
    const el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.warn(`Failed to parse JSON config ${id}`, err);
      return null;
    }
  };

  const initDocumentState = () => {
    document.documentElement.classList.replace('no-js', 'js');
    if (window.Shopify && Shopify.designMode) {
      document.documentElement.classList.add('shopify-design-mode');
    }
  };

  const ensureInstantJS = () => {
    window.InstantJS = window.InstantJS || {};
    if (!window.InstantJS.track) {
      window.InstantJS.trackQueue = [];
      window.InstantJS.track = function track() {
        window.InstantJS.trackQueue.push(arguments);
      };
    }
  };

  const patchFacebookTracking = () => {
    const trackEvent = (() => {
      const sent = new Set();
      return (eventArgs) => {
        const serialized = JSON.stringify(eventArgs);
        if (sent.has(serialized) || !eventArgs[0].includes('track')) return;
        sent.add(serialized);
        window.InstantJS.track('MARKETING_PIXEL_EVENT_FIRED', [
          { event: eventArgs, provider: 'META_PLATFORMS' },
        ]);
      };
    })();

    const wrapFbq = () => {
      if (window.fbq?.callMethod) {
        const original = window.fbq;
        const wrapped = function wrappedFbq() {
          trackEvent([...arguments]);
          return original.apply(this, arguments);
        };
        Object.keys(original).forEach((key) => {
          wrapped[key] = original[key];
        });
        window.fbq = wrapped;
      } else {
        setTimeout(wrapFbq, 1);
      }
    };

    const wrapFbqQueue = () => {
      const { _fbq } = window;
      if (_fbq && _fbq.queue) {
        _fbq.queue.forEach((item) => trackEvent([...item]));
        const originalPush = _fbq.queue.push;
        _fbq.queue.push = function pushWrapped(...args) {
          trackEvent([...args[0]]);
          return originalPush.apply(_fbq.queue, args);
        };
      } else {
        setTimeout(wrapFbqQueue, 1);
      }
    };

    wrapFbq();
    wrapFbqQueue();
  };

  const initGtag = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'AW-867594121');
  };

  const initUET = () => {
    (function init(w, d, t, r, u) {
      let f;
      let n;
      let i;
      w[u] = w[u] || [];
      f = function createUET() {
        const o = { ti: '97148719', tm: 'shpfy_ui', enableAutoSpaTracking: true };
        o.q = w[u];
        w[u] = new UET(o);
        w[u].push('pageLoad');
      };

      n = d.createElement(t);
      n.src = r;
      n.async = 1;
      n.onload = n.onreadystatechange = function handleReady() {
        const s = this.readyState;
        if (!s || s === 'loaded' || s === 'complete') {
          f();
          n.onload = n.onreadystatechange = null;
        }
      };
      i = d.getElementsByTagName(t)[0];
      i.parentNode.insertBefore(n, i);
    })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
  };

  const initFullStory = () =>
    new Promise((resolve) => {
      window._fs_host = 'fullstory.com';
      window._fs_script = 'edge.fullstory.com/s/fs.js';
      window._fs_org = 'o-1ZP4M4-na1';
      window._fs_namespace = 'FS';
      (function fs(m, n, e, t, l, o, g, y) {
        if (m[e]) return;
        g = m[e] = function initFs() {
          g.q ? g.q.push(arguments) : g._api(arguments);
        };
        g.q = [];
        o = n.createElement(t);
        o.async = 1;
        o.src = `https://${l}`;
        y = n.getElementsByTagName(t)[0];
        y.parentNode.insertBefore(o, y);
      })(window, document, window._fs_namespace, 'script', window._fs_script);

      const checkReady = setInterval(() => {
        if (typeof window.FS === 'function') {
          clearInterval(checkReady);
          resolve(window.FS);
        }
      }, 50);
      setTimeout(() => {
        clearInterval(checkReady);
        resolve(window.FS);
      }, 4000);
    });

  const applyFullStoryIdentity = (fsReady) => {
    const customerData = readJsonConfig('fs-customer-data');
    if (!customerData) return;
    fsReady?.then((FS) => {
      if (typeof FS !== 'function') return;
      FS('setIdentity', {
        uid: customerData.id,
        properties: {
          displayName: customerData.displayName,
          email: customerData.email,
          custom_field: 1,
        },
      });
    });
  };

  const setThemeGlobals = () => {
    const data = readJsonConfig('theme-global-data');
    if (!data) return;
    window.shopUrl = data.shopUrl;
    window.routes = data.routes;
    window.cartStrings = data.cartStrings;
    window.variantStrings = data.variantStrings;
    window.quickOrderListStrings = data.quickOrderListStrings;
    window.accessibilityStrings = data.accessibilityStrings;
    window.variantSellingPlans = [];
    window.supplyDays = [];
  };

  // const initRebuyCartHandler = () => {
  //   let hasBootstrapped = false;

  //   const hideAllButFirstOfEachBundle = () => {
  //     const elementsWithBundleId = Array.from(document.querySelectorAll('[class*=\"_bundleid:\"]'));
  //     elementsWithBundleId.forEach((element) => {
  //       if (/_bundleid:[a-zA-Z0-9]+/.test(element.className)) {
  //         element.style.display = 'none';
  //       }
  //     });

  //     if (typeof initLoopBundle === 'function') {
  //       initLoopBundle('rebuy-cart__flyout');
  //     }
  //   };

  //   const getCartItems = async () => {
  //     try {
  //       const response = await fetch('https://www.healthycell.com/cart.js');
  //       const data = await response.json();
  //       return data?.items || [];
  //     } catch (err) {
  //       console.warn('Unable to fetch cart data for bundles', err);
  //       return [];
  //     }
  //   };

  //   const bootstrapRebuyCartProductsSection = async () => {
  //     if (hasBootstrapped) return;
  //     hasBootstrapped = true;
  //     window.Loop = window.Loop || {};
  //     window.Loop.bundleCartAllItems = await getCartItems();
  //     hideAllButFirstOfEachBundle();
  //   };

  //   const handleDrawerVisibility = (target) => {
  //     const observer = new MutationObserver((mutationsList) => {
  //       mutationsList.forEach((mutation) => {
  //         if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
  //         const classAdded = target.classList.contains('is-visible');
  //         const classWasPresent = mutation.oldValue && mutation.oldValue.includes('is-visible');
  //         if (classAdded && !classWasPresent) {
  //           const flyoutObserver = new MutationObserver((entries, obs) => {
  //             const parentEle = document.querySelector('.rebuy-cart__flyout');
  //             if (parentEle) {
  //               obs.disconnect();
  //               bootstrapRebuyCartProductsSection();
  //             }
  //           });
  //           flyoutObserver.observe(document.body, { childList: true, subtree: true });
  //         }
  //       });
  //     });

  //     observer.observe(target, { attributes: true, attributeOldValue: true });
  //   };

  //   const observeForDrawer = () => {
  //     const targetNode = document.getElementById('rebuy-cart');
  //     if (targetNode) {
  //       handleDrawerVisibility(targetNode);
  //       return;
  //     }

  //     const observer = new MutationObserver((mutations, obs) => {
  //       const found = document.getElementById('rebuy-cart');
  //       if (found) {
  //         obs.disconnect();
  //         handleDrawerVisibility(found);
  //       }
  //     });

  //     observer.observe(document.body, { childList: true, subtree: true });
  //   };

  //   observeForDrawer();
  // };

  const initRebuyCartHandler = () => {
  let hasBootstrapped = false;
  const LOOP_ITEMS_CLASS = 'loop-rebuy-items';

  const tagItemsContainer = () => {
    const ul = document.querySelector('ul[data-smartcart-items]');
    if (ul && !ul.classList.contains(LOOP_ITEMS_CLASS)) {
      ul.classList.add(LOOP_ITEMS_CLASS);
    }
    return ul;
  };

  const hideAllButFirstOfEachBundle = () => {
    const elementsWithBundleId = Array.from(document.querySelectorAll('[class*="_bundleid:"]'));
    elementsWithBundleId.forEach((element) => {
      if (/_bundleid:[a-zA-Z0-9]+/.test(element.className)) {
        element.style.display = 'none';
      }
    });

    if (typeof initLoopBundle === 'function') {
      initLoopBundle(LOOP_ITEMS_CLASS);
    }
  };

  const getCartItems = async () => {
    try {
      const response = await fetch('https://www.healthycell.com/cart.js');
      const data = await response.json();
      return data?.items || [];
    } catch (err) {
      console.warn('Unable to fetch cart data for bundles', err);
      return [];
    }
  };

  const bootstrapRebuyCartProductsSection = async () => {
    if (hasBootstrapped) return;
    hasBootstrapped = true;
    window.Loop = window.Loop || {};
    window.Loop.bundleCartAllItems = await getCartItems();
    tagItemsContainer();
    hideAllButFirstOfEachBundle();
  };

  const handleDrawerVisibility = (target) => {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
        const classAdded = target.classList.contains('is-visible');
        const classWasPresent = mutation.oldValue && mutation.oldValue.includes('is-visible');
        if (classAdded && !classWasPresent) {
          // Reset so we re-bootstrap each time the drawer opens
          hasBootstrapped = false;

          const flyoutObserver = new MutationObserver((entries, obs) => {
            const itemsUl = document.querySelector('ul[data-smartcart-items]');
            if (itemsUl) {
              obs.disconnect();
              bootstrapRebuyCartProductsSection();
            }
          });
          flyoutObserver.observe(document.body, { childList: true, subtree: true });

          // Safety timeout — disconnect if UL never shows up
          setTimeout(() => flyoutObserver.disconnect(), 5000);
        }
      });
    });

    observer.observe(target, { attributes: true, attributeOldValue: true });
  };

  const observeForDrawer = () => {
    const targetNode = document.getElementById('rebuy-cart');
    if (targetNode) {
      handleDrawerVisibility(targetNode);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const found = document.getElementById('rebuy-cart');
      if (found) {
        obs.disconnect();
        handleDrawerVisibility(found);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  observeForDrawer();
};

  const scheduleTrackers = () => {
    const loadHyros = () =>
      loadScript(
        'https://182063.tracking.hyros.com/v1/lst/universal-script?ph=d0cc2b2e3372bf7e6a509a79c815b73f332db5c22463b13b3724d51ade1289c6&tag=!tracking',
        { async: true }
      );

    const loadPodsights = () =>
      loadScript('https://cdn.pdst.fm/ping.min.js', { id: 'pdst-capture', async: true }).then(
        () => {
          window.pdst =
            window.pdst ||
            function pdst() {
              (window.pdst.q = window.pdst.q || []).push(arguments);
            };
          window.pdst('conf', { key: '070cf40089a44b4fadd525868b13c3fb' });
          window.pdst('view');
        }
      );

    const loadQuantcast = () => {
      window._qevents = window._qevents || [];
      window._qevents.push({
        qacct: 'p-Yfq88eLNUMVnP',
        uid: '__INSERT_EMAIL_HERE__',
      });
      const base = document.location.protocol === 'https:' ? 'https://secure' : 'http://edge';
      return loadScript(`${base}.quantserve.com/quant.js`, { async: true });
    };

    const loadPromoPirates = () => {
      window.ppShop = 'healthycellshop.myshopify.com';
      return loadScript('https://promopirates.com/cdn/promo-pirates-alpha.js', { defer: true });
    };

    const loadXpPixel = () =>
      loadScript('https://xp2023-pix.s3.amazonaws.com/px_4QzzC.js', { async: true });

    const run = () => {
      loadHyros();
      loadPodsights();
      loadQuantcast();
      loadPromoPirates();
      loadXpPixel();
    };

    loadAfterIdle(run);
  };

  window.custom = function custom(variantID, productID) {
    const variantId = variantID;
    const productData =
      typeof getLoopProductData === 'function' ? getLoopProductData(productID) : null;
    if (typeof loopVariantChanged === 'function') {
      loopVariantChanged({ loopProduct: productData, variantId });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    initDocumentState();
    ensureInstantJS();
    patchFacebookTracking();
    initGtag();
    initUET();
    const fsReady = initFullStory();
    applyFullStoryIdentity(fsReady);
    setThemeGlobals();
    initRebuyCartHandler();
    scheduleTrackers();
  });
})();
